import { render, staticRenderFns } from "./AboutApp.vue?vue&type=template&id=3a23988c&scoped=true&"
import script from "./AboutApp.vue?vue&type=script&lang=js&"
export * from "./AboutApp.vue?vue&type=script&lang=js&"
import style0 from "./AboutApp.vue?vue&type=style&index=0&id=3a23988c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23988c",
  null
  
)

export default component.exports